import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService, SelectItem } from 'primeng/api';
import { Observable, Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromStore from '../../../store';
import { Store, select } from '@ngrx/store';
import * as fromFeature from '../../../my-features';
import { Confirm_button } from '../../../../environments/environment';
import {CryptoService} from '../../../services/crypto.service';
import { updateInfoType } from '../../../shareModel';
import * as moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UpdateInfoModel } from '../../../my-features/updateInfo/update-info.model';

@Component({
  standalone: false,
  selector: 'app-mib-detail',
  templateUrl: './mib-detail.component.html',
  styleUrls: ['./mib-detail.component.css']
})
export class MibDetailComponent implements OnInit {
  private componentDestroyed = new Subject();
  Confirm_button = Confirm_button;
  MIBMgtList_cols: any[] = [
    // { field: 'id', header: 'Id', width: '150', class: 'col-nowrap', disabled: true },
    { field: 'category', header: 'Category', width: '150', class: 'col-nowrap', disabled: false },
    { field: 'OidName', header: 'OID Name', width: '250', class: 'col-nowrap', disabled: false },
    { field: 'Oid', header: 'OID', width: '300', class: 'col-nowrap', disabled: false },
    { field: 'access', header: 'Access', width: '150', class: 'col-nowrap', disabled: false },
    // { field: 'attriId', header: 'Attribute Id', width: '150', class: 'col-nowrap', disabled: true },
    { field: 'attributeName', header: 'Attribute Name', width: '200', class: 'col-nowrap', disabled: false },
    { field: 'desc', header: 'Description', width: '280', class: 'col-nowrap', disabled: false },
    { field: 'operators', header: 'Operators', width: '120', class: 'col-nowrap', disabled: false },
    { field: 'operands', header: 'Number', width: '120', class: 'col-nowrap', disabled: false },
  ];
  MIBMgtDetailList = [];
  selectedMIB: any;
  dialogInput: {
    Id?: number;
    UpdateType: string;
    category: number;
    OidName: string;
    Oid: string;
    access: number;
    attributeName: string;
    attriId: number;
    desc: string;
    operators: number;
    operands: number;
  };
  categoryOptions: SelectItem[] = [];
  attributeOptions: SelectItem[] = [];
  operatorsOptions: SelectItem[] = [
    { label: 'Please Select:', value: null},
    { label: 'x', value: 0},
    { label: '/', value: 1 },
    { label: '+', value: 2 },
    { label: '-', value: 3 },
  ];
  accessOptions: SelectItem[] = [
    { label: 'Read', value: 0 },
    { label: 'Read-Write', value: 1 },
  ];
  displayDialog: boolean = false;
  displayConfirmDialog: boolean = false;
  mib_Id: number;
  mib_Brand: string;
  mib_Name: string;
  mib_LastUpdateTime: string;
  gatewayMIBMgtDetailList = [];
  gatewayAttributeDataDic = [];
  gatewayAttributeByCategoryDic = [];
  gatewayCategoryDic = [];
  isChanging= false;
  defaultOperands = 0.1;
  categoryList = [];
  UpdateInfoParam = {} as UpdateInfoModel;
  constructor(
    private router: Router,
    private store: Store<fromStore.State>,
    private cryptoService: CryptoService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService) { 
    this.mib_Id = parseInt(this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('hashId')), 10);
    const param = {
      otp: '',
      InfoId: this.mib_Id
    }
    this.ngxService.start();
    this.store.dispatch(new fromFeature.ReadMgtMibDetail(param));
    this.store.dispatch(new fromFeature.ReadMgtAttribute());
    this.store.dispatch(new fromFeature.ReadCategoryListByUser());

    // Get User Info
    this.store.pipe(select(fromStore.getCurrentUser)).subscribe(res => {
      if (res.authority && res.authority !== 2) {
        this.router.navigate(['/index']);
      }
    });

    combineLatest(this.store.select(fromStore.ReadMgtMibDetail), this.store.select(fromStore.ReadMgtAttribute), this.store.select(fromStore.ReadCategoryList),).pipe(takeUntil(this.componentDestroyed))
    .subscribe(([mibdata, attributedata, categoryList] ) => {
      if ((categoryList !== undefined && categoryList !== null)) {
        if (categoryList.length > 0) {
          this.gatewayCategoryDic = [];
          this.categoryList = [];
          this.categoryOptions = [];
          [...categoryList].sort(function (a: any, b: any) {
            return a.Value - b.Value;
          }).map((c) => {
            this.gatewayCategoryDic[c.Value] = c;
            this.categoryList.push(c)
            this.categoryOptions.push({
              label: c.Category, value: c.Value
            })
          })
        }
      }
      if ((mibdata !== undefined && mibdata !== null) && (attributedata !== undefined && attributedata !== null)) {
          this.ngxService.start();
          this.gatewayMIBMgtDetailList = mibdata;
          this.gatewayAttributeByCategoryDic = [];
          attributedata.map((a) => {
            this.gatewayAttributeDataDic[a.Id] = a;
            if(this.gatewayCategoryDic[a.Category] !== undefined) {
              if (this.gatewayAttributeByCategoryDic[this.gatewayCategoryDic[a.Category].Value] !== undefined) {
                this.gatewayAttributeByCategoryDic[this.gatewayCategoryDic[a.Category].Value].push(a)
              } else {
                this.gatewayAttributeByCategoryDic[this.gatewayCategoryDic[a.Category].Value] = [];
                this.gatewayAttributeByCategoryDic[this.gatewayCategoryDic[a.Category].Value].push(a)
              }
            }
          })
          this.getMIBMgtDetailList(mibdata);
        }
    });

    // Update Info
    this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.isLoading && res.isLoaded) {
        if (res.type === updateInfoType.AddMgtMibDetail || res.type === updateInfoType.UpdateMgtMibDetail || res.type === updateInfoType.DeleteMgtMibDetail) {
          
          this.messageService.clear();
          if (res.isSaved) {
            const param = {
              otp: '',
              InfoId: this.mib_Id
            }
            this.store.dispatch(new fromFeature.ReadMgtMibDetail(param));
            this.messageService.add({ severity: 'success', summary: res.msg });
          } else {
            this.messageService.add({ severity: 'error', summary: res.msg });
          }
          this.resetUpdateInfoState();
        }
      }
    })
  }

  ngOnInit() {
    this.initDialogInput();
  }

  getMIBMgtDetailList(res) {
    if (res!== undefined) {
      if (this.gatewayAttributeDataDic.length > 0) {
        this.MIBMgtDetailList = [];
        this.mib_Brand = res.Brand;
        this.mib_Name = res.Name;
        this.mib_LastUpdateTime = res.UpdateTime !== null ? moment(Number(res.UpdateTime) * 1000).format('YYYY/MM/DD') : '';
        if (res.Data !== undefined && res.Data.length > 0) {
          res.Data.map((m)=>{
            const item = {
              id: m.Id,
              category: m.Category,
              OidName: m.OidName,
              Oid: m.Oid,
              desc: m.Description,
              access: m.AccessType,
              operators: m.Operator,
              operands: m.Operator !== null ? m.Operands : null,
              attriId: m.AttriId,
              attributeOptions: [],
              attributeName: this.gatewayAttributeDataDic[m.AttriId] !== undefined ? this.gatewayAttributeDataDic[m.AttriId].AttrName : ''
            }
            
            if (this.gatewayAttributeByCategoryDic !== undefined && this.gatewayAttributeByCategoryDic[m.Category] !== undefined) {
              item.attributeOptions.push({ label: "Please Select:", value: -1});
              this.gatewayAttributeByCategoryDic[m.Category].map((c)=>{
                item.attributeOptions.push({ label: c.AttrName, value: c.Id});
              })
            }
            this.MIBMgtDetailList.push(item);
          })
          
          this.ngxService.stop();
        }
      }
      this.ngxService.stop();
    }
  }

  initDialogInput() {
    this.dialogInput = {
      Id: 0,
      UpdateType: 'Add SNMP MIB',
      category: 0,
      OidName: '',
      Oid: '',
      access: 0,
      attributeName: '',
      attriId: null,
      desc: null,
      operators: null,
      operands: null,
    };
  }

  showDialog() {
    this.initDialogInput();
    this.displayDialog = true;
  }

  showEditDialog() {
    this.displayDialog = true;
    this.dialogInput = {
      Id: this.selectedMIB.id,
      UpdateType: 'Edit SNMP MIB',
      category: this.selectedMIB.category,
      OidName: this.selectedMIB.OidName,
      Oid: this.selectedMIB.Oid,
      access: this.selectedMIB.access,
      attriId: this.selectedMIB.attriId,
      attributeName: this.selectedMIB.attributeName,
      desc: this.selectedMIB.desc,
      operators: this.selectedMIB.operators,
      operands: this.selectedMIB.operands,
    };
  }

  saveMIBData() {
    let param = {
      otp: '',
      Oid: this.dialogInput.Oid,
      OidName: this.dialogInput.OidName,
      AccessType: this.dialogInput.access
    } as any;

    if (this.dialogInput.desc !== undefined && this.dialogInput.desc !== null) {
      param = {...param, Description: this.dialogInput.desc}
    }
    if (this.dialogInput.attriId !== undefined && this.dialogInput.attriId !== null) {
      param = {...param, AttriId: this.dialogInput.attriId}
    }
    if (this.dialogInput.operators !== undefined && this.dialogInput.operators !== null) {
      param = {...param, Operator: this.dialogInput.operators}
      if (this.dialogInput.operands !== undefined && this.dialogInput.operands !== null) {
        param = {...param, Operands: this.dialogInput.operands}
      }
    }
    if (this.dialogInput.UpdateType === 'Add SNMP MIB') {
      param = {...param,
        InfoId: this.mib_Id,
        Category: this.dialogInput.category
      }
      this.store.dispatch(new fromFeature.AddMgtMibDetail(param));
    } else {
      param = {...param, Id: this.selectedMIB.id}
      this.store.dispatch(new fromFeature.UpdateMgtMibDetail(param));
    }
    this.displayDialog = false;
  }

  showConfirmDialog() {
    this.displayConfirmDialog = true;
  }

  deleteMIBData() {
    const param = {
      otp: '',
      Id: this.selectedMIB.id
    }
    this.store.dispatch(new fromFeature.DeleteMgtMibDetail(param));
    this.displayConfirmDialog = false;
  }

  backClicked() {
    this.router.navigate(['/management/gateway']);
  }

  changeCategory() {
    this.attributeOptions = [];
    if (this.gatewayAttributeByCategoryDic !== undefined && this.gatewayAttributeByCategoryDic[this.dialogInput.category] !== undefined) {
      this.attributeOptions.push({ label: "Please Select:", value: null});
      this.gatewayAttributeByCategoryDic[this.dialogInput.category].map((c)=>{
        this.attributeOptions.push({ label: c.AttrName, value: c.Id});
      })
    }
  }

  operatorsOnChange(e) {
    
    if (this.dialogInput.operators === null) {
      this.dialogInput.operands = null
    } else {
      if (this.dialogInput.operands === undefined || this.dialogInput.operands === null) {
        this.dialogInput.operands = this.defaultOperands
      }
    }
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }
}
